<template>

<dev
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
   
    style="width: 100%">
 
  </dev>

</template>

<script>

import { getAjsHeaderInfo } from "@/api/open";
import {getLibrary, getQuestionnaireQrCodeById} from "@/api/study";
export default {
  data() {
    return {
      loading:true,
      headerInfo: {},
      libraryInfo: {},
      libraryId: null,
      qrcode: null,
    };
  },
 
  created() {
    if (this.$route.query.libraryId) {
      this.libraryId = this.$route.query.libraryId;
    }
    this.getOpenData();
  
  },
  mounted() {
    
  },


  methods: {
  
  getOpenData() {
    var _this= this;
    getAjsHeaderInfo().then(response => {
      this.headerInfo = response.data;
      sessionStorage.setItem('headerInfo',JSON.stringify(this.headerInfo));
      _this.getLibraryInfo();
    });
  },
  getLibraryInfo(){
    getLibrary(this.libraryId).then(response=>{
      this.libraryInfo = response.data;
      //debugger
      sessionStorage.setItem('libraryInfo',JSON.stringify(this.libraryInfo));
      if (this.libraryInfo.questionnaireId) {
        this.getQuestionnaireQrCode();
      } else {
        this.$router.push({name:'home',query: {libraryId: this.libraryId,automatic:this.$route.query.automatic ,time:this.$route.query.time,address:this.$route.query.address,showPage:this.$route.query.showPage}})
      }
      
    })
  },
  getQuestionnaireQrCode() {
    
    getQuestionnaireQrCodeById(this.libraryInfo.questionnaireId).then(response=>{
      this.qrcode = response.data.qrcode;
      
      if (this.qrcode) {
        sessionStorage.setItem('questionnaireQrcode',this.qrcode);
      }
      this.$router.push({name:'home',query: {libraryId: this.libraryId,automatic:this.$route.query.automatic ,time:this.$route.query.time,address:this.$route.query.address,showPage:this.$route.query.showPage}})
    })
  }
  
  
  }
};
</script>

<style>
.videos {
  position: absolute;
  right: 0;
  top: 120px;
}
.right {
  float: right;
  margin-right: 1%;
}
.top20 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue